<template>
    <div class="company-form-container">
        <!-- barsha -->

        <div class="col-sm-12  px-3 ibox  no-shadow employee-table-wrapper">
            <!-- <div class="row no-gutters py-2 mb-3 mt-3"> -->
                <ul class="list-group mb-3 " v-if='errormsg'>
                    <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{ data[0] }}</li>
                </ul>
                <div class="row no-gutters py-2 mb-3 pl-2 ">
                    <div class="col-sm-6 company-form-box-title">Migrated GF History</div>
                    <template v-if="flg > 0">
                        <div class="col-sm-6 cursor-pointer text-right company-form-box-title">
                            <button
                                @click="addNew()" class="btn btn-block btn-secondary tab-button mx-2 mt-0">Add GF History
                            </button> 
                            <button @click="addGFDate()" class="btn btn-block btn-secondary tab-button mt-0">Add
                                GF Enrollment Date </button></div>
                    </template>

                </div>
            <!-- </div> -->
            <b-overlay :show="showoverlay_list" rounded="sm">
                <div class="mx-2 px-0" v-if="mgfs.length > 0">
                    <table class="table">
                        <thead>
                            <tr class="table-head">
                                <td>Fiscal Year </td>
                                <td>Employer Contribution</td>
                                <td>Last Activity<span class="custom-date-indicator d-block ess-date-indicator">(DD/MM/YYYY)</span></td>
                                <td>Activity By</td>
                                <td>Action</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hover-bg table-row border-bottom mx-2" v-for="mgf in mgfs" :key="mgf.id">

                                <td class="align-middle list-columns">{{ mgf.fiscal_year }}</td>

                                <td class="align-middle list-columns">
                                    <template v-if="decimal_setting == 'no'">{{
                                        moneyFormat(Math.round(mgf.employer_contribution))
                                    }}</template><template v-else>{{ moneyFormat(mgf.employer_contribution)}}</template>
                                </td>

                                <td class="align-middle list-columns">
                                    <template v-if="mgf.updated_at != null">{{ formatMe(mgf.updated_at) }}</template>
                                    <template v-else>{{ formatMe(mgf.created_at) }}</template>
                                </td>
                                <td class="align-middle list-columns">
                                    <template v-if="mgf.updated_by == null">
                                        Not Available
                                    </template>
                                    <template v-else>
                                        {{ mgf.updated_by }}
                                    </template>
                                </td>



                                <td class="list-columns align-middle" v-if="flg > 0">
                                    <b-button-toolbar class="position-relative text-right justify-content-end"
                                        v-if="mgf.flg == 1">
                                        <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                            style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false"><b-icon
                                                icon="three-dots-vertical"></b-icon></a>
                                        <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
                                            <b-button-group class="mr-1">
                                                <b-button variant="outline-secondary" title="Edit MGF" @click="editMgf(mgf.id)">
                                                    <i class="fa fa-pencil-alt"></i> Edit
                                                </b-button>
                                                <b-button variant="outline-secondary" title="Delete MGF" @click="deleteMgf(mgf.id)">
                                                    <b-icon icon="trash" aria-hidden="true"></b-icon> Delete
                                                </b-button>
                                            </b-button-group>
                                        </div>
                                    </b-button-toolbar>
                                    <div class="text-center float-right" v-else
                                        title="This entry can't be edited or deleted since a payrun has been approved after this was listed."
                                        v-b-tooltip placement="right">
                                        <b-icon icon="info-circle"></b-icon>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="" v-else>
                    No Migrated Gratuity Fund History Found!
                </div>

            </b-overlay>
        </div>

        <!-- barsha -->
        <b-modal id="bv-modal-example" :modal-class="'w-600'" size="lg" hide-footer title="Add Gratuity Fund History Details">
            <b-form @submit.stop.prevent="onSubmit">
                <div class="clearfix">

                    <div class="col-md-12 float-left">

                        <input type="hidden" v-model="fdata.id" name="id">
                        <b-form-group id="fiscal_year-group" label="Fiscal Year" class="required-field"
                            label-for="fiscal_year">
                            <b-form-select id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year"
                                v-validate="{ required: true }" :options="$fiscal_year_options"
                                :state="validateState('fiscal_year')" aria-describedby="fiscal_year-feedback"
                                data-vv-as="fiscal_year"></b-form-select>
                            <b-form-invalid-feedback id="gender-feedback">{{ veeErrors.first('gender')
                            }}</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group id="employer_contribution-group" label="Employer Contribution" class="required-field"
                            label-for="employer_contribution">
                            <b-form-input id="employer_contribution" name="employer_contribution"
                                v-model="fdata.employer_contribution" v-validate="{ required: true, decimal: 2 }"
                                :state="validateState('employer_contribution')"
                                aria-describedby="employer_contribution-feedback"
                                data-vv-as="Employer Contribution"></b-form-input>
                            <b-form-invalid-feedback id="employer_contribution-feedback">{{
                                veeErrors.first('employer_contribution') }}</b-form-invalid-feedback>
                        </b-form-group>

                    </div>
                </div>

                <div class="col-md-12 text-center mt-4 mb-4 clearfix" style="margin-right: 18px;">
                    <b-button class="border rounded py-1 px-5 mt-4 ml-2 custom-wizard-btn btn-primary" variant="success"
                        @click="resetForm()">Reset</b-button>
                    <b-button class="border rounded py-1 px-5 mt-4 ml-2 btn-primary" type="submit"
                        variant="success">Submit</b-button>
                    
                </div>

            </b-form>
        </b-modal>

        <b-modal id="bv-modal-gf" size="lg" :modal-class="'w-600'" hide-footer title="Add/Update Gratuity Fund Enrollment Date">
            <b-form @submit.stop.prevent="onSubmitGF">
                <div class="clearfix">

                    <div class="col-md-12 float-left">

                        <b-form-group id="enrollment_date-group" label="Enrollment Date *" label-for="enrollment_date">
                            <b-input-group class="mb-3">
                                
                                    <b-form-input id="enrollment_date" name="enrollment_date"
                                        v-model="gfdata.gf_enrollment_date" v-validate="{ required: true }" type="text"
                                        placeholder="YYYY-MM-DD" autocomplete="off"
                                        :state="validateState('enrollment_date')"
                                        aria-describedby="enrollment_date-feedback"
                                        data-vv-as="Enrollment Date"></b-form-input>
                                        <b-input-group-append>
                                            <b-form-datepicker id="day_one" button-only right locale="en-US"
                                        v-model="gfdata.gf_enrollment_date"></b-form-datepicker>
                                        </b-input-group-append>
                                    

                                <b-form-invalid-feedback id="enrollment_date-feedback">{{ veeErrors.first('enrollment_date')
                                }}</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group id="number_of_month-group" label="Number of Month *" label-for="number_of_month">
                            <b-form-input id="number_of_month" name="number_of_month" v-model="gfdata.gf_enrolled_month"
                                v-validate="{ required: true }" :state="validateState('number_of_month')"
                                aria-describedby="number_of_month-feedback" data-vv-as="Number Of Month"></b-form-input>
                            <b-form-invalid-feedback id="number_of_month-feedback">{{ veeErrors.first('number_of_month')
                            }}</b-form-invalid-feedback>
                        </b-form-group>
                    </div>
                </div>

                <div class="col-md-12 text-center mt-4 mb-4 clearfix" style="margin-right: 18px;">
                    <b-button class="border rounded  py-1 px-5 mt-4 ml-2 custom-wizard-btn btn-primary" variant="success"
                        @click="getMgfHistory()">Reset</b-button>
                    <b-button class="border rounded py-1 px-5 mt-4 ml-2 btn-primary" type="submit"
                        variant="success">Submit</b-button>
                    
                </div>

            </b-form>
        </b-modal>
    </div>
</template>
<script>
import moment from 'moment';

export default {

    mounted() {

        this.flg = 1;

        //console.log(this.employee_id);  
    },
    props: ['pageurl', 'flg'],
    data() {

        return {
            itabIndex: 0,
            fiscal_year: this.getCurrentFinancialYear(),

            //fiscal_years:[],

            mgfs: [],

            successmsg: null,
            errormsg: [],
            fdata: { fiscal_year: this.getCurrentFinancialYear(), amount: null, id: null },
            gfdata: [],
            pgurl: this.$api_url,

            decimal_setting: 'yes',

            showoverlay_list: false,

        }
    },
    methods: {
        formatMe(d) {
            return moment(d).format('DD/MM/YYYY hh:mm:ss A');
        },
        moneyFormat(amount) {
            var money = Number(amount);
            money = money.toLocaleString();
            if (this.decimal_setting == 'yes' || this.decimal_setting == '')
                if (money.indexOf(".") < 0)
                    money = money + '.00';
            return money;
        },

        getMgfs: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;

            axios.get(this.$api_url + '/mgf/list', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.mgfs = response.data;

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        getMgfHistory: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;

            axios.get(this.$api_url + '/mgf/get-gf-enrollment-history', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.gfdata = response.data;


                console.log(this.gfdata);

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        editMgf: function (x) {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/mgf/details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.fdata = response.data;
                this.successmsg = null;
                this.$bvModal.show('bv-modal-example');
            }.bind(this)).catch(function (error) { currentObj.serverError(error); });

        },

        deleteMgf: function (x) {
            if (!this.checkNet()) return false;
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this Migrated GF.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {
                        this.resetForm();
                        this.showoverlay_list = true;
                        let currentObj = this;
                        let formData = new FormData();
                        formData.append('id', x);

                        axios.post(this.$api_url + '/mgf/delete', formData).then(function (response) {

                            if (response.data.status == true) {
                                this.successmsg = response.data.meg;
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                                this.getMgfs();
                            }
                            this.showoverlay_list = false;

                        }.bind(this)).catch(function (error) { currentObj.showoverlay_list = false; currentObj.serverError(error); });
                    }
                })
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = { fiscal_year: this.getCurrentFinancialYear(), id: null };

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        resetFormGF() {
            this.gfdata = { gf_enrolled_month: null, gf_enrollment_date: null };

            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        addNew() {
            this.resetForm();
            this.$bvModal.show('bv-modal-example');
        },
        addGFDate() {
            this.resetForm();
            this.$bvModal.show('bv-modal-gf');
        },


        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                e.preventDefault();
                let currentObj = this;
                const config = {
                    //headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                axios.post(this.$api_url + '/mgf/save', formData, config)
                    .then(function (response) {
                        this.resetForm();
                        this.getMgfs();
                        this.itabIndex = 1;

                        this.$bvToast.toast("Saved", {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.$bvModal.hide('bv-modal-example');

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.serverError(error);
                        //currentObj.errormsg = error.response.data.errors;
                    });
            });
        },

        onSubmitGF(e) {
            if (!this.checkNet()) return false;
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }

                e.preventDefault();
                let currentObj = this;
                const config = {
                    //headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                for (let [key, value] of Object.entries(this.gfdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    console.log(`${key}: ${value}`);
                }

                axios.post(this.$api_url + '/mgf/save-gf-enrollment-history', formData, config)
                    .then(function (response) {
                        this.resetFormGF();
                        this.getMgfHistory();
                        this.itabIndex = 1;

                        this.$bvToast.toast("Saved", {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.$bvModal.hide('bv-modal-gf');

                    }.bind(this))
                    .catch(function (error) {
                        currentObj.serverError(error);
                        //currentObj.errormsg = error.response.data.errors;
                    });

            });
        },
        get_decimal_settings: function () {
            axios.get(this.$api_url + '/decimal-settings')

                .then(function (response) {
                    this.decimal_setting = response.data;
                }.bind(this));
        },

    },
    created: function () {

        this.getMgfHistory();
        this.getMgfs();
        this.get_decimal_settings();
    }
}
</script>
